export default {
  path: '/system/cities',
  meta: {
    title: '省市区管理'
  }
};
